import _applicantProfile from "./index.vue";
export default {
  path: "applicants/:slug",
  name: "applicantprofile",
  component: _applicantProfile,
  meta: {
    title: "Applicant's Profile",
    user: "employee",
  },
};
